import { goRequest } from '../utils/httpClientTs';
import {
  PermissionOption,
  PermissionRecord,
  CreatePermissionRequest,
  UpdatePermissionRequest,
  GenericResponse,
} from '../types/permissions';

/**
 * Get all permissions for selectors
 * @returns Promise<PermissionOption[]>
 */
export const getAllPermissions = async (): Promise<PermissionOption[]> => {
  return goRequest<PermissionOption[]>({
    url: '/api/permissions/list',
    method: 'GET',
  });
};

/**
 * List permission records with optional filters
 * @param groupTypeId - Optional filter by group type ID
 * @param permissionId - Optional filter by permission ID
 * @returns Promise<PermissionRecord[]>
 */
export const listPermissions = async (
  groupTypeId?: string,
  permissionId?: string
): Promise<PermissionRecord[]> => {
  const params: Record<string, string> = {};
  if (groupTypeId) {
    params.group_type_id = groupTypeId;
  }
  if (permissionId) {
    params.permission_id = permissionId;
  }

  return goRequest<PermissionRecord[]>({
    url: '/api/permissions',
    method: 'GET',
    params,
  });
};

/**
 * Create a new permission record
 * @param data - Permission creation data
 * @returns Promise<PermissionRecord>
 */
export const createPermission = async (
  data: CreatePermissionRequest
): Promise<PermissionRecord> => {
  return goRequest<PermissionRecord>({
    url: '/api/permissions',
    method: 'POST',
    data,
  });
};

/**
 * Update a permission record
 * @param id - Permission record ID
 * @param data - Permission update data
 * @returns Promise<GenericResponse>
 */
export const updatePermission = async (
  id: string,
  data: UpdatePermissionRequest
): Promise<GenericResponse> => {
  return goRequest<GenericResponse>({
    url: `/api/permissions/${id}`,
    method: 'PATCH',
    data,
  });
};

/**
 * Delete a permission record
 * @param id - Permission record ID
 * @returns Promise<GenericResponse>
 */
export const deletePermission = async (
  id: string
): Promise<GenericResponse> => {
  return goRequest<GenericResponse>({
    url: `/api/permissions/${id}`,
    method: 'DELETE',
  });
};
